import {updatePowtoonContent} from './updatePowtoonContent'
import {recoverPowtoonContentPromise, regenerateManifestForServerFromDoc} from './powtoonRecovery'


import {validate} from './powtoonContentVersions'

export const validateByLastVersion = async (powtoon, options) => {
  const validationResult = await validate(powtoon, options)
  if (!validationResult) {
    return validationResult
  }
  return {
    errors: validationResult.errors.map(error => ({
      ...error,
      dataPath: error.dataPath || error.instancePath.replace(/\//g, '.')
    })),
    errorMessage: validationResult.errorMessage
  }
}

export {initValidate, latestVersion} from './powtoonContentVersions'


export {updatePowtoonContent, recoverPowtoonContentPromise, regenerateManifestForServerFromDoc}
